function iOSMajorVersion() {
  if (!process.browser) return;
  if (/iP(hone|od touch|ad)/.test(window.navigator.platform)) {
    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    var v = window.navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    return parseInt(v[1], 10); // parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
  }
}

export default iOSMajorVersion;
